import { OPERATION_ERROR, SHOW_PROGRESS } from "../../../constants/action_types";

export const operationError = (state = { error: '', errorHandled: false }, action = null) => {
    switch (action.type) {
        case OPERATION_ERROR:
            console.log(action);
            console.log(action.Error.Error);
            return {
                ...state,
                error: action.error.message,
                errorHandled: action.errorHandled
            }
        default:
            return state;
    }
}

export const showProgress = (state = false, action) => {
    switch (action.type) {
        case SHOW_PROGRESS:
            return action.show;
        default:
            return state;
    }
}